import { Injectable } from "@angular/core";

/**
 * FeatureUtilsService
 * --------------------------------------------------------------------
 * Pure helpers that used to live on the legacy `ApiService`:
 *  - `getImageUrl` — base path for image assets
 *  - `renameFeatures` — normalises feature keys to display labels
 *  - `formattedApiCallError` — simple boolean flag
 */
@Injectable({ providedIn: "root" })
export class FeatureUtilsService {
  private _formattedApiCallError = false;

  get formattedApiCallError(): boolean {
    return this._formattedApiCallError;
  }
  set formattedApiCallError(value: boolean) {
    this._formattedApiCallError = value;
  }

  /** Base path for image assets. */
  getImageUrl(_hostName?: string): string {
    return "/assets/img/";
  }

  /** Rename feature keys to their human-readable labels. */
  renameFeatures(array: string[]): string[] {
    const renames: ReadonlyArray<[string, string]> = [
      ["CLOLite", "CLOLite"],
      ["Ast", "AST"],
      ["SrPsu", "SR PSU"],
      ["Ztv", "ZTV"],
    ];
    for (const [oldName, newName] of renames) {
      const index = array.indexOf(oldName);
      if (index > -1) {
        array.splice(index, 1);
        array.push(newName);
      }
    }
    return array;
  }
}
